module.exports = __webpack_public_path__ + "img/3.32dda95 1.55369cb.svg";